// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.01c5aafb',
  revision: '01c5aafb',
  branch: 'develop',
  date: 'Thu, 12 Feb 2026 15:17:02 GMT'
};